// useContextMenuPosition.js — klampar en fixed-positionerad högerklicksmeny så
// att den aldrig hamnar utanför skärmen (Spår B).
//
// Menyn renderas först på muspekarens råa x/y. Efter mount mäter vi menyns
// verkliga storlek (offsetWidth/offsetHeight) och jämför mot fönstret. Ryms den
// inte nedåt vänder vi upp den (top = y - höjd); ryms den inte till höger vänder
// vi vänster (left = x - bredd). Går den ändå inte att få plats klampar vi mot
// nederkant/högerkant. useLayoutEffect körs före paint → ingen synlig hoppning.
import { useState, useLayoutEffect } from 'react';

const MARGIN = 8; // px marginal mot fönsterkanten

export default function useContextMenuPosition(menuRef, visible, x, y) {
  const [pos, setPos] = useState({ top: y, left: x });

  useLayoutEffect(() => {
    if (!visible || !menuRef.current) return;

    const { offsetWidth: w, offsetHeight: h } = menuRef.current;
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    let top = y;
    if (y + h + MARGIN > vh) {
      // Vänd uppåt om menyn får plats ovanför pekaren, annars klampa mot nederkant
      top = y - h >= MARGIN ? y - h : Math.max(MARGIN, vh - h - MARGIN);
    }

    let left = x;
    if (x + w + MARGIN > vw) {
      left = x - w >= MARGIN ? x - w : Math.max(MARGIN, vw - w - MARGIN);
    }

    setPos({ top, left });
  }, [menuRef, visible, x, y]);

  return pos;
}
